import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { Map } from 'immutable';

import Button from '@material-ui/core/Button';

import ReduxDialog from '../../../Common/ReduxDialog';
import { hasPermission } from '../../../../utils/authenticated';

import { showDialog, hideDialog, showError, showConfirm } from '../../../../redux/actions/dialogs';

import { required } from '../../../../utils/formvalidation';
import { name, toArray } from '../../../../utils/helper';
import { getDialogContextValue } from '../../../../redux/selectors';
import { EXCEPTION_DIALOG } from '../../../../redux/constants/dialogs';
import { resolveExceptionFormHandler } from '../../../../redux/routines';

import styles from './styles';
import { renderTextField } from '../../../../utils/reduxforms';
import Status from '../../../Common/Status';
import { formatLocation } from '../../../../utils/helper';
import Identifier from '../../../Common/Identifier';

const getExceptionType = ({ type }) => {
  switch (type.code) {
    case 'MissingItem':
      return 'Missing';
    case 'UnexpectedItem':
      return 'Unexpected';
    default:
      return 'Unknown Exception for';
  }
};

const getModalTitle = ({ type = { code: 'Unknown' }, item, stage }) => {
  return `${getExceptionType({ type })} ${item.type.name} during ${stage.name}`;
};

class ExceptionDialog extends Component {
  componentWillMount() {
    this.setState({
      editable: hasPermission(['JobCreator', 'Administrator']),
    });
  }

  confirmResolve = () => {
    return new Promise((resolve, reject) => {
      const message = 'Are you sure you wish to resolve this exception?';
      this.props.showConfirm({
        title: message,
        onConfirm: () => {
          this.props.submit(EXCEPTION_DIALOG);
        },
        onReject: reject,
      });
    });
  };

  renderIdentifiers = (identifiers = []) => {
    if (identifiers.length === 0) {
      return null;
    }

    return (<Grid item xs={12}>
      <Typography variant="caption">Identifiers</Typography>
      {identifiers.map((identifier) => (
        <Identifier key={identifier.id} identifier={identifier}/>))}
    </Grid>);
  };

  render() {
    const { handleSubmit, initialValues, hideDialog, submit } = this.props;
    const { editable, uploading, tab } = this.state;

    const { exception } = initialValues.toJS();

    const actions = editable ? [
      <Button
        key="cancel"
        variant="text"
        onClick={() => hideDialog(EXCEPTION_DIALOG)}
        disabled={uploading}
      >Cancel</Button>,
      <Button
        key="resolve"
        variant="contained"
        color="primary"
        autoFocus
        onClick={this.confirmResolve}
        disabled={uploading}
      >Resolve</Button>] : null;

    return (
      <ReduxDialog
        name={EXCEPTION_DIALOG}
        title={getModalTitle(exception)}
        actions={actions}
        bodyStyle={styles.body}
        fullWidth
        maxWidth="sm"
      >
        <Form onSubmit={handleSubmit(resolveExceptionFormHandler)} style={styles.container}>
          <Grid container spacing={8}>
            <Grid item xs={6}>
              <TextField
                label="Origin"
                value={formatLocation(exception.task.origin)}
                readOnly
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Intended Destination"
                value={formatLocation(exception.task.destination)}
                readOnly
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Exception Location"
                value={formatLocation(exception.occurredAt)}
                readOnly
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Exception Created"
                value={`${name(exception.created.by)} at ${moment(exception.created.at).format('lll')}`}
                readOnly
                fullWidth
              />
            </Grid>

            {this.renderIdentifiers(exception.item.identifiers)}
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

ExceptionDialog.propTypes = {
  // resolveException: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: EXCEPTION_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog(EXCEPTION_DIALOG);
  },
})(ExceptionDialog);

function mapStateToProps(state,) {
  return {
    initialValues: new Map()
      .set('exception', getDialogContextValue(state)(EXCEPTION_DIALOG, 'exception'))
      .set('jobId', getDialogContextValue(state)(EXCEPTION_DIALOG, 'jobId')),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      showDialog,
      hideDialog,
      showError,
      showConfirm,
    }, dispatch),
    ...bindPromiseCreators({
      // saveCustomerLogo: saveCustomerLogoPromise,
    }, dispatch)
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Reports/ExceptionsReport/ExceptionDialog/index.js